<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box invest-with-us">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<!-- <h1>Questions about<br>business loans from<br>American Credit®?</h1> -->
              <h1>Contact us</h1>
							<br />
							<button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none;">Apply Now</button>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Try us now. See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="invest-with-us-main-img" src="../assets/imgs/contact_us_american_credit.png" alt="american credit contact us"/>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%; background: white;" id="contact-form">
      <div class="container platform contact-us">
        <div class="row">
          <div class="col-12 col-lg-5 offset-lg-1 contact-us-left">
            <h4 class="contact-us-title">Drop us a line</h4>
            <p class="contact-us-text">Whether you want to learn about our business funding or have questions about business finance in general, our loan specialists are here to help!</p>
            <el-form class="row" :label-width="'0'" :model="step2Form" :rules="rules" ref="step2Form">
              <el-form-item class="col-6 hide-label" prop="firstName" label="First Name" required>
                <el-input type="text" placeholder="First Name*" v-model="step2Form.firstName"></el-input>
              </el-form-item>
              <el-form-item class="col-6 hide-label" prop="lastName" label="Last Name" required>
                <el-input type="text" placeholder="Last Name*" v-model="step2Form.lastName"></el-input>
              </el-form-item>
              <el-form-item class="col-6 hide-label" prop="email" label="Email" required>
                <el-input type="text" placeholder="Email*" v-model="step2Form.email"></el-input>
              </el-form-item>
              <el-form-item class="col-6 hide-label" prop="phone" label="Phone" required>
                <el-input type="tel" placeholder="Phone*" v-model="step2Form.phone"></el-input>
              </el-form-item>
              <el-form-item class="col-12 hide-label" prop="content" label="How Can We Help?">
                <el-input type="textarea" placeholder="How Can We Help?" v-model="step2Form.content"></el-input>
              </el-form-item>
              <br />
              <div class="col-12">
                <el-button
                  type="primary"
                  :loading="isLoading"
                  class="rounded-pill font-weight-bold"
                  @click="submitForm"
                  style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 54px; width: 190px; border-radius: 27px; border: none; margin-top: 36px;"
                >Send Message</el-button>
                <el-form-item label prop></el-form-item>
              </div>
            </el-form>
          </div>
          <div class="col-12 col-lg-5 contact-us-right">
            <h4 class="contact-us-title">Get in touch with us</h4>
            <p class="contact-us-text">We understand. Sometimes you just want to get a few answers and move on with business.</p>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_location.png" alt="american credit location">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Address</h5>
                <p style="white-space: nowrap;">2100 Geng Road, Suite 210<br /> Palo Alto, CA 94303</p>
              </div>
            </div>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_phone.png" alt="american credit phone">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Phone</h5>
                <p><a href="tel:1855-904-0188">855-904-0188</a></p>
              </div>
            </div>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_email.png" alt="american credit email">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Email</h5>
                <p><a href="mailto:info@amcredit.com">info@amcredit.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../vuex/types";
import _ from "lodash";
import api from "../vuex/api/index";

export default {
  data() {
    return {
      isLoading: false,
      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      },
      rules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Phone is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    submitForm() {
      this.$refs['step2Form'].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          var _this = this;
          api
            .postForm("/common/sysfeedback/mgxyContact.ht", {
              tokenId: _this.userInfo.token,
              lastName: _this.step2Form.lastName,
              firstName: _this.step2Form.firstName,
              email: _this.step2Form.email,
              phone: _this.step2Form.phone,
              content: _this.step2Form.content
            })
            .then(res => {
              this.isLoading = false;
              this.$router.push({
                path: `/thank-you`,
                query: {}
              });
            });
        } else {
          console.log('error submit!!');
        }
      });
    }
  }, //end of methods
  mounted() {
    var seo = document.getElementById("seo")

    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }
    
    var keywords=document.getElementById("seokeywords");
    if(!keywords){
    keywords=document.createElement("meta");
    keywords.name="keywords";
    keywords.id="seokeywords"
    document.head.insertBefore(keywords,seo);
    }

    document.title = "Contact Us | American Credit";
    meta.content = "Contact American Credit today to help find the perfect business lending solution for your specific needs and goals. Quick Decision. Quick Funding. Apply Now!";
    keywords.content = "american credit background, business financing, american credit history, american credit";
  }
};
</script>

<style scoped lang="scss">
	@import "../assets/css/global.scss";
  @import "../assets/css/fonts.css";
  
  .business-loan-box-left-inner {
    margin-top: 220px !important;
  }

  @media (max-width: 768px) {
    .business-loan-box-left-inner {
      margin-top: 0 !important;
      padding-top: 20px;
      padding-bottom: 40px;
    }
  }
</style>

<style lang="scss">
  .hide-label .el-form-item__label {
    display: none;
    width: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// contactUs.vue?4e1c99ce